import css from 'styled-jsx/css';

const styles = css.global`#santander-conhecer-financiamento {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), #222;
  /* height: 426px; */
  position: relative;
  overflow: hidden;
}

#santander-conhecer-financiamento .santander-conhecer-financiamento-contain {
  padding: 29px 0 88px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

#santander-conhecer-financiamento .conhecer-text-1 {
  color: #FFF;
  text-align: center;
  font-family: "SantanderHeadline";
  font-size: 26px;
  font-style: normal;
  font-weight: 900;
  line-height: 36px;
  margin-top: 0;
}

#santander-conhecer-financiamento .conhecer-number {
  color: #FFF;
  text-align: center;
  font-family: "SantanderHeadline";
  font-size: 56px;
  font-style: normal;
  font-weight: 900;
  line-height: 60px;
  margin-top: 8px;
}

#santander-conhecer-financiamento .conhecer-text-2 {
  color: #FFF;
  text-align: center;
  font-family: "SantanderText";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-top: 24px;
}

#santander-conhecer-financiamento #home-conhecer-financiamento {
  margin-top: 24px;
  z-index: 3;
  width: 100%;
  max-width: 272px;
  height: 48px;
}

#santander-conhecer-financiamento .img-vehicle {
  position: absolute;
  top: -13px;
  opacity: .05;
  width: 200px;
  left: -33px;
}

#santander-conhecer-financiamento .elipses {
  background-image: url("assets/home24/elipse.png");
  width: 176px;
  height: 232px;
  position: absolute;
  bottom: -30px;
  right: -40px;
  opacity: .3;
}

@media (min-width: 800px) {
  /* #santander-conhecer-financiamento {
    height: 519px;
  } */

  #santander-conhecer-financiamento .santander-conhecer-financiamento-contain {
    padding: 64px 0 67px;
  }

  #santander-conhecer-financiamento .conhecer-text-1 {
    font-size: 48px;
  }
  
  #santander-conhecer-financiamento .conhecer-number {
    font-size: 118px;
    margin-top: 40px;
    font-weight: 400;
  }
  
  #santander-conhecer-financiamento .conhecer-text-2 {
    font-size: 32px;
    margin-top: 40px;
  }
  
  #santander-conhecer-financiamento #home-conhecer-financiamento {
    margin-top: 96px;
    max-width: 272px;
  }
  
  #santander-conhecer-financiamento .img-vehicle {
    top: -22px;
    width: auto;
    left: 0;
  }
  
  #santander-conhecer-financiamento .elipses {
    width: 272px;
    height: 232px;
    bottom: -19px;
    right: -40px;
  }
}`;

export default styles;